import React, { Component } from "react";
import { connect } from "react-redux";
import Typography from "material-ui/Typography";
import Profiles from "../data/Profiles.json";
import { Link } from "react-router-dom";
import Button from "material-ui/Button";
import getProfile from "../utils/getProfile";

class ProfileView extends Component {
  state = {};

  constructor(props) {
    super(props);

    // let iIndex = parseInt(props.quiz.questions.length, 10);
    // //Check if they did the test
    // if (props.quiz.questions[iIndex - 3].givenAnswers.length === 0) {
    //   history.push(`/quiz/1`);
    // }

    this.state = {
      profile: getProfile(props.quiz.questions)
    };
  }

  breakLine(text) {
    var br = React.createElement("br");
    var regex = /(<br \/>)/g;
    return text.split(regex).map(function(line, index) {
      return line.match(regex) ? <br key={"key_" + index} /> : line;
    });
  }

  render() {
    let profile_letters="";
    let sProfileText_state = "";
    let sProfileText_title = "";
    let sProfileText_text_title_1 = "";
    let sProfileText_text_title_2 = "";
    let sProfileText_text_1 = "";/*declare the variable for storing 'intro description' from the json file*/

    // let listItems = "";


    //Read the profiles from data/Profiles.json
    profile_letters=this.state.profile;
    if (!Profiles.profiles[this.state.profile]) {
      sProfileText_state =
        "The following profile doens't exist yet: " + this.state.profile;
    } else {

      // sProfileText_state = this.breakLine(Profiles.profiles[this.state.profile]);

      sProfileText_state = this.breakLine(
        Profiles.profiles[this.state.profile].state
      );
      sProfileText_title = this.breakLine(
        Profiles.profiles[this.state.profile].title
      );
      sProfileText_text_title_1 = this.breakLine(
        Profiles.profiles[this.state.profile].text_title_1
      );
      sProfileText_text_title_2 = this.breakLine(
        Profiles.profiles[this.state.profile].text_title_2
      );
      sProfileText_text_1 = this.breakLine(
        Profiles.profiles[this.state.profile].text_1
      );

    }
    const color1 = { color: "#bf0d3e" };
    const color2 = { color: "#897222" };
    const color3 = { color: "#8146af" };
    const color4 = { color: "#eaaa02" };
    const color5 = { color: "#64a70a" };

    const title_purple = {
      color: "#8146af",
      fontWeight: "bold",
      fontSize: "1.5em",
      marginTop: "30px"
    };
    const title_darkblue = {
      color: "#0b2440",
      fontWeight: "bold",
      fontSize: "1.2em",
    };
    const subtitle_darkblue = {
      color: "#0b2440",
      fontWeight: "bold",
      fontSize: "0.7em"
    };

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Typography
                component="div"
                style={{
                  margin: "20px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  textAlign: "left"
                }}
              >

                <span style={color1}>These Lenses</span>
                <span style={color2}> are linked to</span>
                <span style={color3}> Personal qualities,</span>
                <span style={color4}>the Earth Charter </span>
                <span style={color3}> and </span>
                <span style={color5}> the Sustainable Development Goals </span>
              </Typography>
              <Typography
                component="div"
                style={{
                  marginLeft: "20px",
                  marginTop: "30px",
                  fontWeight: "bold",
                  textAlign: "left",
                  fontSize: "0.7em"
                }}
              >
                These lenses serve as a guide to look at your personal talents
                articles and the articles of the Earth Charter and the SDG’s.
                From this perspective you can translate relevant articles into a
                development steps with your personal talents
              </Typography>

              <Typography
                component="div"
                style={{
                  marginLeft: "20px",
                  marginTop: "30px",
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  textAlign: "left",
                  fontSize: "1.2em",
                  lineHeight:"28px"
                }}
              >
                <span style={color3}>
                  What is your focus?<br />
                  {sProfileText_title}
                </span>
              </Typography>

              <Typography
                component="p"
                style={{
                  margin: "20px",
                  textAlign: "left",
                  fontWeight: "lighter"
                }}
              >
                <span style={subtitle_darkblue}>{profile_letters}<br/></span>
                <span style={title_purple}>{sProfileText_text_title_1}<br/></span>
                <span style={title_darkblue}>{sProfileText_text_title_2}<br/></span>
                <br/>
                {sProfileText_text_1}

                </Typography>
                <Link to={"/articles"}>
                  <Button
                    variant="raised"
                    style={{ marginBottom: "10px"}}
                    color="primary"
                    //onClick={()=> reloadMe()}
                  >
                    Next
                  </Button>
                </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps({ quiz }, { match: { params } }) {
  return {
    quiz
  };
}
function reloadMe() {
    window.location.reload();
}

export default connect(mapStateToProps)(ProfileView);



// WEBPACK FOOTER //
// ./src/views/ProfileView.jsx